// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { HexagonSpinner } from '@imprivata-cloud/patient-access-ui-components';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

// P1 Start. Informational only in this slice: the Figma frame is a loading state and there
// is no continue action until the capture slice.
const ServiceDeskStart: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Flex vertical align="center" data-testid="service-desk-start">
      <Typography.Title level={2} className="text-center" data-testid="service-desk-start-title">
        {t('serviceDesk.loading')}
      </Typography.Title>
      <HexagonSpinner aria-label={t('serviceDesk.loading')} data-testid="loading-spinner" />
    </Flex>
  );
};
export default ServiceDeskStart;
